/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ComplaintDetail, GetComplaintByIdRequest, GetComplaintByIdState } from "store/modules/complaints/types";

const initialState: GetComplaintByIdState = {
    isRequesting: false,
    successPayload: null,
    errors: []
};

const getComplaintByIdSlice = createSlice({
    name: "complaints@getComplaintById",
    initialState,
    reducers: {
        getComplaintByIdRequest: (
            state,
            action: PayloadAction<GetComplaintByIdRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        getComplaintByIdSuccess: (
            state,
            action: PayloadAction<ComplaintDetail>
        ): void => {
            state.isRequesting = false;
            state.successPayload = action.payload;
        },
        getComplaintByIdFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.successPayload = null;
            state.errors = action.payload;
        }
    }
});

export const {
    getComplaintByIdRequest,
    getComplaintByIdSuccess,
    getComplaintByIdFailed
} = getComplaintByIdSlice.actions;
export default getComplaintByIdSlice.reducer;
